import React, { Fragment, useState } from 'react'

import ThemeMenuTwo from '../../components/header/ThemeMenuTwo'
import ThemeBannerTwo from '../../components/theme-banner/ThemeBannerTwo'
import FeatureThree from '../../components/feature/FeatureThree'
import BlockStyleThree from '../../components/block/BlockStyleThree'
import CounterTwo from '../../components/counter/CounterTwo'
import FeatureFour from '../../components/feature/FeatureFour'
import CaseSliderOne, {
    CASE_SLIDER_B2C_ECOMMERCE_ITEM,
    CASE_SLIDER_B2C_MOBILE_ITEM,
    CASE_SLIDER_BLOCKCHAIN_ITEM,
    CASE_SLIDER_DIGITAL_ASSETS_EXCHANGE_ITEM,
    CASE_SLIDER_PREMIUM_AUTO_CONCIERGE_ITEM,
} from '../../components/case-study/CaseSliderOne'
import VideoSliderOne from '../../components/video/VideoSliderOne'
import BlockStyleFive from '../../components/block/BlockStyleFive'
import BlockStylFive from '../../components/block/BlockStylFive'
import FeedbackTwo from '../../components/testimonial/FeedbackTwo'
import FooterTwo from '../../components/footer/FooterTwo'
import ModalVideos from '../../components/modal-video/ModalVideos'

const REVENUE_FEATURE_THREE = [
    {
        icon: 'icon-15b',
        title: '실시간 매출·정산 가시화',
        desc: '매장·채널·상품 단위로 매출과 정산 흐름을 즉시 확인하고, 일·월 마감 리포트까지 한 화면에서 운영할 수 있도록 설계합니다.',
        dataAos: 'fade-up',
        dataDelay: '',
    },
    {
        icon: 'icon-16b',
        title: 'POS·온라인·배달 연동',
        desc: '이종 채널 데이터를 표준 포맷으로 모아 중복 없이 집계합니다. 기존 PG·키오스크·OMS와의 연동 경험을 바탕으로 안정적인 파이프라인을 구축합니다.',
        dataAos: 'fade-up',
        dataDelay: '50',
    },
    {
        icon: 'icon-17b',
        title: '권한·감사 대응 운영',
        desc: '본사·지점·파트너별 조회 권한, 이력 로그, 승인 프로세스를 반영해 내부 통제와 외부 감사 요구에 대비한 운영 구조를 지원합니다.',
        dataAos: 'fade-up',
        dataDelay: '100',
    },
]

const REVENUE_FEATURE_FOUR = [
    {
        thumb3d: 3,
        thumb3dSrc: '/assets/img/services/admin-system.png',
        tone: 'admin',
        chips: ['대시보드', '일·월 마감'],
        title: '매출·정산 통합 콘솔',
        desc: '실시간 매출, 할인·환불, 현금·카드·간편결제 내역을 통합해 본사와 현장이 동일한 숫자를 보도록 하는 관리자·운영 화면을 구축합니다.',
        dataAos: 'fade-up',
        dataDelay: '',
    },
    {
        thumb3d: 2,
        thumb3dSrc: '/assets/img/services/data-business-system.png',
        tone: 'data',
        chips: ['채널 분석', '매장 KPI'],
        title: '채널·매장별 매출 분석',
        desc: '온라인몰, 오프라인 POS, 배달 플랫폼별 매출과 전환을 비교하고, 기간·지역·브랜드 단위로 경영 리포트를 자동 생성합니다.',
        dataAos: 'fade-up',
        dataDelay: '100',
    },
    {
        thumb3d: 2,
        thumb3dSrc: '/assets/img/services/api-backend.png',
        tone: 'api',
        chips: ['연동', '데이터 표준화'],
        title: '외부 시스템·PG 연동',
        desc: '기존 결제·재고·배송 시스템과 API로 연결해 매출 원장이 끊기지 않게 하고, 장애 시 재처리·백필 정책까지 포함한 연동 계층을 설계합니다.',
        dataAos: 'fade-up',
        dataDelay: '150',
    },
    {
        thumb3d: 1,
        thumb3dSrc: '/assets/img/services/erp-integration.png',
        tone: 'erp',
        chips: ['회계', '세금계산서'],
        title: '회계·ERP 정산 연동',
        desc: '매출 집계 결과를 회계 전표·부가세 신고·세금계산서 발행 흐름과 맞추어 이관하고, 더존·영림원 등 국내 패키지와의 맞춤 연동을 지원합니다.',
        dataAos: 'fade-up',
        dataDelay: '200',
    },
    {
        thumb3d: 1,
        thumb3dSrc: '/assets/img/services/saas-platform.png',
        tone: 'saas',
        chips: ['멀티 지점', '가맹'],
        title: '본사·가맹 통합 통계',
        desc: '다지점·가맹 구조에서 본사는 전체 매출과 정책을, 매장은 자기 구역 데이터만 보도록 테넌트·롤 모델을 적용한 SaaS형 운영을 구현합니다.',
        dataAos: 'fade-up',
        dataDelay: '250',
    },
    {
        thumb3d: 5,
        thumb3dSrc: '/assets/img/services/maintenance-performance.png',
        tone: 'ops',
        chips: ['모니터링', '장애 대응'],
        title: '정산 배치·운영 모니터링',
        desc: '야간 정산·대사 배치, 알림·대시보드로 누락 건을 조기에 발견하고, 성능·용량 이슈를 지속 점검해 매출 피크에도 안정적으로 운영합니다.',
        dataAos: 'fade-up',
        dataDelay: '300',
    },
]

const REVENUE_CASE_SLIDER_ITEMS = [
    CASE_SLIDER_PREMIUM_AUTO_CONCIERGE_ITEM,
    CASE_SLIDER_DIGITAL_ASSETS_EXCHANGE_ITEM,
    CASE_SLIDER_BLOCKCHAIN_ITEM,
    CASE_SLIDER_B2C_ECOMMERCE_ITEM,
    CASE_SLIDER_B2C_MOBILE_ITEM,
]

const RevenueManagementSolution = () => {
    const [open, setOpen] = useState(false)
    const OpenModal = () => {
        setOpen(!open)
    }

    return (
        <Fragment>
            <ModalVideos isOpen={open} onClick={OpenModal} />
            <div className="main-page-wrapper">

                <ThemeMenuTwo />
                <ThemeBannerTwo
                    heroImage1="/assets/img/hero/software-development-hero.png"
                    heroImage1Alt="매출·정산 대시보드와 채널별 지표를 보여 주는 매출관리 솔루션 히어로 이미지"
                    heroImage2="/assets/img/hero/revenue-management-hero-circle.webp"
                    heroImage2Alt="매출관리 솔루션 히어로 원형 비주얼"
                    subTitle="실시간 매출 가시화 · 정산 자동화"
                    titleLines={['채널 매출을', '한곳에서', '매출관리 솔루션']}
                />

                <section className="codam-feature pt-150 pb-30 pt-lg-120">
                    <div className="container">
                        <FeatureThree items={REVENUE_FEATURE_THREE} />
                    </div>
                </section>

                <section className="about-codam-two pt-75 pb-105 pt-lg-40 pb-lg-20 pt-md-30 pb-md-15">
                    <img className="about-shape shape-1b" src="assets/img/shape/star-3b.svg" alt="배경 도형" />
                    <img className="about-shape shape-2b" src="assets/img/shape/star-4b.svg" alt="배경 도형" />
                    <img className="about-shape shape-3b d-none d-md-inline-block" src="assets/img/shape/star-2.svg" alt="배경 도형" />
                    <img className="about-shape shape-4b" src="assets/img/shape/star-5b.svg" alt="배경 도형" />
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5 align-items-center">
                            <div className="col-xxl-5 col-xl-4 col-md-6 order-2" data-aos="fade-up" data-aos-delay={100}>
                                <div className="about-img-wrapper-two about-img-wrapper-two--slot-500x650 text-lg-end position-relative mb-45">
                                    <img
                                        className="main-img"
                                        src="/assets/img/about/revenue-management-operations-structure.png"
                                        alt="매장·본사·정산 데이터가 중앙 DB로 통합되는 매출관리 운영 구조"
                                        loading="lazy"
                                        decoding="async"
                                    />
                                    <img className="shape-one" src="assets/img/shape/line-round-4a.svg" alt="배경 도형" />
                                </div>
                            </div>
                            <div className="col-xxl-4 col-xl-4 col-md-6 order-1" data-aos="fade-up" data-aos-delay={100}>
                                <BlockStyleThree
                                    kicker="매출관리 솔루션"
                                    title="매출 데이터가 흩어지지 않는 운영 구조"
                                    body="현장 매출부터 본사 정산, 회계 반영까지 단절 없이 이어지도록 설계합니다. 표준 데이터 모델과 권한 체계를 먼저 잡고, 연동·리포트·배치를 그 위에 얹어 장기적으로 확장 가능한 매출 인프라를 만듭니다."
                                    linkTo="/contact"
                                    linkLabel="도입 문의하기"
                                />
                            </div>
                            <div className="col-xxl-3 col-xl-4 order-3" data-aos="fade-left" data-aos-delay={100}>
                                <CounterTwo />
                            </div>
                        </div>
                    </div>
                </section>

                <section className="our-services codam-services-page service-bg-two pt-95 pb-50 pt-lg-50 pb-lg-15">
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5 align-items-center justify-content-center">
                            <div className="col-xl-5 col-lg-6 col-md-8">
                                <div className="section-title text-center mb-55">
                                    <h2 className="sect-title mb-25" data-aos="fade-up">
                                        매출관리 핵심 기능
                                    </h2>
                                    <p data-aos="fade-up" data-aos-delay={100}>
                                        집계·분석·정산·연동까지 매출 운영에 필요한 모듈을 단계적으로 구축합니다. 이미 쓰는 시스템과의 공존을
                                        전제로 설계합니다.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <FeatureFour items={REVENUE_FEATURE_FOUR} />
                    </div>
                </section>

                <section className="latest-case-work slick-nav blog-slick pt-145 pb-150 pt-lg-60 pb-lg-120">
                    <img className="case-shape shape-1b d-none d-lg-inline-block" src="assets/img/shape/star-3b.svg" alt="배경 도형" />
                    <img className="case-shape shape-2b d-none d-lg-inline-block" src="assets/img/shape/star-4b.svg" alt="배경 도형" />
                    <img className="case-shape shape-3b d-none d-lg-inline-block" src="assets/img/shape/star-2.svg" alt="배경 도형" />
                    <img className="case-shape shape-4b d-none d-lg-inline-block" src="assets/img/shape/star-5b.svg" alt="배경 도형" />
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5 align-items-center">
                            <div className="col-xl-5 col-lg-6 col-md-8">
                                <div className="section-title mb-55 text-md-start text-center">
                                    <h6 className="sub-title mb-20" data-aos="fade-up">
                                        구축 사례
                                    </h6>
                                    <h2 className="sect-title mb-25" data-aos="fade-up" data-aos-delay={100}>
                                        매출·운영 시스템 프로젝트
                                    </h2>
                                </div>
                            </div>
                        </div>
                        <CaseSliderOne items={REVENUE_CASE_SLIDER_ITEMS} />
                    </div>
                </section>

                <section className="latest-case-video slick-nav">
                    <div className="container-fluid px-lg-0">
                        <div className="row gx-4 gx-xxl-5 align-items-center">
                            <div className="col-md-6 pb-sm-45">
                                <VideoSliderOne
                                    openModal={OpenModal}
                                    imageSrc="/assets/img/video/revenue-management-operational-insight.png"
                                    imageAlt="대형 모니터와 대시보드로 매출·운영 지표를 분석하는 운영팀 협업 장면"
                                />
                            </div>
                            <div className="col-xxl-4 col-md-6">
                                <BlockStyleFive
                                    kicker="운영 인사이트"
                                    title="정산·피크 시간대까지 고려한 안정 운영"
                                    body="매출이 몰리는 시간대와 월말 정산 배치에 맞춰 부하를 분산하고, 장애 시 복구·재처리 절차를 문서화해 운영팀이 안심하고 쓸 수 있는 환경을 목표로 합니다."
                                />
                            </div>
                        </div>
                    </div>
                </section>

                <section className="codam-wrok-process pt-140 pb-30 pt-lg-55">
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5">
                            <div className="col-lg-12">
                                <div className="section-title text-center mb-55">
                                    <h6 className="sub-title mb-20">도입 절차</h6>
                                    <h2 className="sect-title">매출 솔루션 구축 프로세스</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row gx-4 gx-xxl-5 align-items-center">
                            <div className="col-xl-7 col-lg-6">
                                <div className="process-img-wrapper process-img-wrapper--slot-610x628 mb-45">
                                    <img
                                        src="/assets/img/work/revenue-management-process.png"
                                        alt="기획·개발·운영 단계를 보여 주는 매출 솔루션 구축 프로세스"
                                        loading="lazy"
                                        decoding="async"
                                    />
                                    <div className="call-box">
                                        <div className="icon">
                                            <img src="assets/img/icon/icon-27b.svg" alt="문의 아이콘" />
                                        </div>
                                        <h3 className="sect-title-two">
                                            매출·정산 요구를
                                            <br />
                                            함께 정리해 보세요
                                        </h3>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-6">
                                <BlockStylFive />
                            </div>
                        </div>
                    </div>
                </section>

                <section className="client-feedback feedback-bg pt-70 pb-110 pb-lg-60">
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5">
                            <div className="col-lg-12">
                                <div className="section-title text-center mb-55">
                                    <h6 className="sub-title mb-20">고객 후기</h6>
                                    <h2 className="sect-title">고객사가 전하는 CODAM 경험</h2>
                                </div>
                            </div>
                        </div>
                        <FeedbackTwo />
                    </div>
                </section>

                <FooterTwo />
            </div>
        </Fragment>
    )
}

export default RevenueManagementSolution
